module.exports = __webpack_public_path__ + "img/baohan-bg.c0f6cb5.png";